<template>
  <div id="need-box">
    <div class="need-box-title">
      提交需求
      <div class="need-box-title-close" @click="closeNeed">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <div>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="80px"
        class="info-form"
      >
        <el-form-item label="企业名称" prop="enterpriseName">
          <el-input v-model="form.enterpriseName"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="person">
          <el-input v-model="form.person"></el-input>
        </el-form-item>
        <!-- <el-form-item label="联系方式" prop="phone">
          <el-input v-model="form.phone">
            <el-button
              slot="append"
              :disabled="phoneDisabled"
              @click="phoneClick"
              :class="phoneDisabled ? '' : 'blue'"
            >
              <span v-if="phoneShow">发送验证码</span>
              <span v-else>重新发送({{ timeCount }}s)</span>
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="form.code"></el-input>
        </el-form-item> -->
        <el-form-item label="所需面积" prop="areaValue">
          <el-row>
            <el-col :span="24">
              <el-input v-model="form.areaValue" type="number">
                <template slot="append">亩</template>
              </el-input>
            </el-col>
            <!-- <el-col :span="6" style="margin-left: 10px">
              <el-button type="primary" icon="el-icon-edit" @click="draw"
                >绘画范围</el-button
              ></el-col
            > -->
          </el-row>
        </el-form-item>

        <el-form-item label="土地用途" prop="landPurpose">
          <el-cascader
            v-model="form.landPurpose"
            :options="tdytList"
            :props="{
              checkStrictly: true,
              value: 'code',
              label: 'name',
              children: 'child',
            }"
            clearable
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="行政区划" prop="countyArr">
          <el-cascader
            v-model="form.countyArr"
            :options="xzqhList"
            :props="{ checkStrictly: true }"
            @change="changeCounty"
            clearable
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="意向园区" prop="parkCode">
          <el-select
            v-model="form.parkCode"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in parkList"
              :key="index"
              :label="item.parkName"
              :value="item.parkCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用途描述" prop="purposeRemark">
          <el-input
            type="textarea"
            v-model="form.purposeRemark"
            :autosize="{ minRows: 4, maxRows: 6 }"
          ></el-input>
        </el-form-item>

        <div class="form-btn">
          <el-button class="btn-submit btn-default" @click="submitBefore"
            >提交</el-button
          >
          <el-button class="btn-default" @click="resetForm('ruleForm')"
            >重置</el-button
          >
        </div>
      </el-form>
    </div>
    <el-dialog width="350px" title="验证" :visible.sync="dialogTableVisible">
      <div>
        <el-form :model="form" label-width="80px" class="info-form">
          <el-row>
            <el-col :span="24">
              <el-form-item label="联系方式" prop="phone" :rules="phone">
                <el-input v-model="form.phone">
                  <el-button
                    slot="append"
                    :disabled="phoneDisabled"
                    @click="phoneClick"
                    :class="phoneDisabled ? '' : 'blue'"
                  >
                    <span v-if="phoneShow">发送验证码</span>
                    <span v-else>重新发送({{ timeCount }}s)</span>
                  </el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!-- <el-button @click="dialogTableVisible = true">验证</el-button> -->
              <el-form-item label="验证码" prop="code" :rules="code">
                <el-input v-model="form.code"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getXzqhList,
  dictionaries,
  getCode,
  getTypeList,
} from "@/api/common/index";
import {
  addRequirement,
  getPhoneCode,
  getXzqhParkList,
} from "@/api/setting/investment";
export default {
  name: "need-box",
  props: {
    mapView: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      form: {
        countyArr: [],
      },
      phone: [
        { required: true, message: "请填写联系电话", trigger: "blur" },
        {
          pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
          message: "请输入合法手机号/电话号",
          trigger: "blur",
        },
      ],
      code: [{ required: true, message: "请填写验证码", trigger: "blur" }],
      rules: {
        person: [{ required: true, message: "请填写联系人", trigger: "blur" }],

        enterpriseName: [
          { required: true, message: "请填写企业名称", trigger: "blur" },
        ],
        areaValue: [
          { required: true, message: "请填写所需面积", trigger: "blur" },
        ],
        // area: [{ required: false, message: "请绘画范围", trigger: "blur" }],
        // landPurpose: [
        //   { required: true, message: "请选择土地用途", trigger: "blur" },
        // ],
        countyArr: [
          { required: true, message: "请选择行政区", trigger: "blur" },
        ],
        purposeRemark: [
          { required: true, message: "请填写用地需求说明", trigger: "blur" },
        ],
      },
      dialogTableVisible: false,
      //行政区划数组
      xzqhList: [],
      tdytList: [],
      loading: false,
      phoneDisabled: false,
      phoneShow: true,
      timeCount: "",
      isGrey: false, //按钮样式
      timer: null, //设置计时器,
      parkList: [],
    };
  },
  watch: {
    // "form.landArr": {
    //   deep: true,
    //   handler(val) {
    //     let index = val.length - 1;
    //     this.form.landPurpose = val[index];
    //   },
    // },
  },
  mounted() {
    this.getXzqh();
    // this.getField("TDYT", "tdytList");
    this.gettdlx();
  },
  methods: {
    phoneClick() {
      if (!this.form.phone) {
        this.$message.error("请输入联系号码");
        return false;
      }
      let case1 = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/.test(this.form.phone);
      if (!case1) {
        this.$message.error("请输入正确的联系号码");
        return;
      }
      let TIME_COUNT = 60;
      if (!this.timer) {
        this.timeCount = TIME_COUNT;
        this.isGrey = true;
        this.phoneShow = false;
        this.phoneDisabled = true;
        this.getCode(this.form.phone);
        this.timer = setInterval(() => {
          if (this.timeCount > 0 && this.timeCount <= TIME_COUNT) {
            this.timeCount--;
          } else {
            this.phoneDisabled = false;
            this.isGrey = false;
            this.phoneShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    getCode(val) {
      getPhoneCode({ phone: val }).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getPark(code) {
      getXzqhParkList(code).then((res) => {
        if (res.data.success) {
          this.parkList = res.data.data;
        }
      });
    },
    gettdlx() {
      getTypeList().then((res) => {
        if (res.data.success) {
          this.tdytList = res.data.data;
        }
      });
    },
    getField(field, identification) {
      let data = { field: field };
      dictionaries(field).then((res) => {
        this[identification] = res.data.data;
      });
    },
    //获取行政区划
    getXzqh() {
      getXzqhList({ key: "53" }).then((res) => {
        if (res.data.success) {
          this.xzqhList = res.data.data;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.county = [];
    },
    submitBefore() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.dialogTableVisible = true;
        }
      });
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let len = this.form.countyArr.length;
          this.form.county = this.form.countyArr[len - 1];
          if (this.form.landPurpose && this.form.landPurpose.length) {
            this.form.landPurpose = this.form.landPurpose.join(",");
          }
          addRequirement(this.form).then((res) => {
            if (res.data.success) {
              this.$message.success(res.data.msg);
              this.closeNeed();
              this.dialogTableVisible = false;
              this.loading = false;
              this.$refs.form.resetFields();
            } else {
              this.$message.error(res.data.msg);
              this.dialogTableVisible = false;
              this.loading = false;
            }
          });
        }
      });
    },
    //选择行政区划定位到当前位置
    changeCounty(val) {
      if (val.length) {
        let len = val.length;
        let index = null;
        if (len == 1) {
          index = 2;
        } else if (len == 2) {
          index = 1;
        } else if (len == 3) {
          index = 0;
        }
        this.getPark(val[val.length - 1]);
        // this.mapView.queryArcGISRestByAttribute(
        //   layerConfig.SSQ_Layer,
        //   index,
        //   `XZQDM like '${val[val.length - 1]}%'`,
        //   (res) => {
        //     if (res.features.length && res.features[0].geometry) {
        //       let zb = res.features[0].geometry.rings;
        //       let extent = this.mapView.getPolygonExtent(zb);
        //       this.mapView.zoomToExtent(
        //         extent[0],
        //         extent[1],
        //         extent[2],
        //         extent[3]
        //       ); //居中地图范围
        //     }
        //   }
        // );
      }
    },
    //绘画
    draw() {
      this.mapView.drawGeometry(
        "Polygon",
        (coords) => {
          this.form.area = JSON.stringify(coords);
          let coordinates = this.mapView.getCenterOfPolygon(coords);
          //绘画范围后选择对应行政区划
          if (coordinates.length) {
            this.mapView.queryArcGISRestByGeometry(
              layerConfig.SSQ_Layer,
              0,
              coords,
              "esriGeometryPoint",
              (res) => {
                if (res.features.length) {
                  let attributes = res.features[0].attributes;
                  if (attributes["XZQDM"]) {
                    getCode({ value: attributes["XZQDM"] }).then((res) => {
                      if (res.data.success && !res.data.msg) {
                        this.$message.error("没有查询到对应行政区划");
                        this.form.county = [];
                      } else {
                        let len = attributes["XZQDM"].length;
                        let county = [];
                        if (len == 6) {
                          let str1 = attributes["XZQDM"].substring(0, 2); //省
                          let str2 = attributes["XZQDM"].substring(0, 4); //市
                          county.push(str1, str2, attributes["XZQDM"]);
                        } else if (len == 4) {
                          let str1 = attributes["XZQDM"].substring(0, 2); //省
                          county.push(str1, attributes["XZQDM"]);
                        } else {
                          county.push(attributes["XZQDM"]);
                        }
                        this.form.county = county;
                      }
                    });
                  }
                }
              }
            );
          }
        },
        true
      );
    },
    closeNeed() {
      this.$emit("close-need");
    },
  },
};
</script>

<style scoped>
#need-box {
  background: #fff;
  border-radius: 6px 6px 0 0;
  overflow: hidden;
  width: 360px;
}
.need-box-title {
  position: relative;
  padding: 10px 0;
  text-align: center;
  background: #157cf3;
  color: #fff;
}
.need-box-title-close {
  position: absolute;
  top: 10px;
  right: 10px;
}
.btn-submit {
  background: #157cf3;
  color: #fff !important;
}
.btn-default {
  color: #157cf3;
  border: 1px solid #157cf3;
}
</style>